import { transformCustomizableText } from '../utils';
import { DYHeroBannerSingleCTAProps } from './DYHeroBannerSingleCTA';
import { HeroBannerSingleCTAData, HeroBannerSingleCTAKind } from './HeroBannerSingleCTA';

export function transformDYTemplateVariables(
  dyTemplateVariables: DYHeroBannerSingleCTAProps['data'],
  kind: HeroBannerSingleCTAKind,
): HeroBannerSingleCTAData {
  const title = dyTemplateVariables.title?.text ? transformCustomizableText(dyTemplateVariables.title) : undefined;
  const subtitle = dyTemplateVariables.subtitle?.text
    ? transformCustomizableText(dyTemplateVariables.subtitle)
    : undefined;
  return {
    title,
    subtitle,
    ctaButton: dyTemplateVariables.ctaButton,
    images: dyTemplateVariables.images,
    kind,
  };
}
